import React, { useEffect } from 'react';
import { Phone, Mail, MapPin, Clock, MessageCircle } from 'lucide-react';
import Navbar from '../components/Navbar';
import PageHero from '../components/PageHero';
import { ContactSection, Footer } from '../components/Footer';

export default function ContactPage() {
  useEffect(() => {
    document.title = 'Contact EasyWorks | VPOB, APOB & GST Experts';
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen bg-[#FAF2E8] font-[Inter]" data-testid="contact-page">
      <Navbar />
      <PageHero
        eyebrow="Contact"
        headline="Talk to a"
        headlineAccent="compliance specialist"
        description="Free consultation, no obligation. We reply within 24 hours on business days — usually within an hour on weekdays."
        category="general"
        subtype="Contact Us"
        service="Contact Us"
        formTitle="Get in touch"
        formSubtitle="Share your requirement and a specialist will call you back."
        formTestId="contact-page-quote-form"
        ctaLabel="Request Callback"
      />

      <section className="bg-white py-14">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          <div className="bg-[#FAF2E8]/60 border border-black/5 rounded-2xl p-6">
            <div className="w-11 h-11 rounded-xl bg-white shadow-sm text-[#F39200] flex items-center justify-center"><Phone size={20} /></div>
            <div className="mt-4 text-xs uppercase tracking-wide text-neutral-500 font-semibold">Phone</div>
            <a href="tel:+919717174320" className="mt-1 block text-lg font-semibold text-neutral-900 hover:text-[#F39200]">+91 9717174320</a>
          </div>
          <div className="bg-[#FAF2E8]/60 border border-black/5 rounded-2xl p-6">
            <div className="w-11 h-11 rounded-xl bg-white shadow-sm text-[#F39200] flex items-center justify-center"><Mail size={20} /></div>
            <div className="mt-4 text-xs uppercase tracking-wide text-neutral-500 font-semibold">Email</div>
            <a href="mailto:bookings@easyworks.in" className="mt-1 block text-lg font-semibold text-neutral-900 hover:text-[#F39200]">bookings@easyworks.in</a>
          </div>
          <div className="bg-[#FAF2E8]/60 border border-black/5 rounded-2xl p-6">
            <div className="w-11 h-11 rounded-xl bg-white shadow-sm text-[#F39200] flex items-center justify-center"><MessageCircle size={20} /></div>
            <div className="mt-4 text-xs uppercase tracking-wide text-neutral-500 font-semibold">WhatsApp</div>
            <a href="https://wa.me/919717174320" target="_blank" rel="noreferrer" className="mt-1 block text-lg font-semibold text-neutral-900 hover:text-[#F39200]">Chat with us</a>
          </div>
          <div className="bg-[#FAF2E8]/60 border border-black/5 rounded-2xl p-6">
            <div className="w-11 h-11 rounded-xl bg-white shadow-sm text-[#F39200] flex items-center justify-center"><Clock size={20} /></div>
            <div className="mt-4 text-xs uppercase tracking-wide text-neutral-500 font-semibold">Hours</div>
            <div className="mt-1 text-lg font-semibold text-neutral-900">Mon – Sat<br /><span className="text-sm font-medium text-neutral-600">10:00 AM – 7:00 PM</span></div>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-5 lg:px-10 mt-8">
          <div className="bg-[#FAF2E8]/60 border border-black/5 rounded-2xl p-6 flex items-start gap-4">
            <div className="w-11 h-11 rounded-xl bg-white shadow-sm text-[#F39200] flex items-center justify-center shrink-0"><MapPin size={20} /></div>
            <div>
              <div className="text-xs uppercase tracking-wide text-neutral-500 font-semibold">Head Office</div>
              <div className="mt-1 text-base font-semibold text-neutral-900">C-110, 1st and 4th Floor, Sunidhi Complex, Ashok Vihar Ph-2, Gurugram, Haryana &mdash; 122017</div>
            </div>
          </div>
        </div>
      </section>

      <ContactSection />
      <Footer />
    </div>
  );
}
